/**
 * Created by Kotkin on 28.06.2017.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import map from 'lodash/map';
import get from 'lodash/get';
import { authConnect, UserProp } from 'auth';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import { emit } from 'helpers/global-events';
import localStorage from 'helpers/local-storage';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import userForm from 'subsys/complaint/user-form';
import Form, { Text } from 'containers/form';
// import { RecaptchaButton } from 'containers/form';
import Row, { Col } from 'components/row';
import Icon, { iconTypes } from 'components/icon';
import Button, { btnThemes } from 'components/button';
import Notification from 'components/notification';

import translates from './complaint-i18n.json';

const bemClasses = new Bem('complaints');
const bemClassesModalFooter = new Bem('modalFooter');

@authConnect()
@apiDecorator
@I18nHoc(translates)
class ComplaintContainer extends Component {
  static propTypes = {
    auth: UserProp, //eslint-disable-line
    data: PropTypes.array, //eslint-disable-line
    entityId: PropTypes.number.isRequired,
    userComplaintHandle: PropTypes.func,
    userComplaint: PropTypes.bool,
    unauthorised: PropTypes.bool,
    closeModal: PropTypes.func,
    currentStep: PropTypes.number,
    changeStep: PropTypes.func,
    entity: PropTypes.string,
    updateEvent: PropTypes.string,
    url: PropTypes.string
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      empty: false
    };

    this.complainHandleClick = this.complainHandleClick.bind(this);

    this.stepItem = [];
  }

  onSubmit =()=> {
    this.props.closeModal(true);
    emit(this.props.updateEvent || '');
  };

  sendComplaint(data = null) {
    const { entity = '', updateEvent = '' } = this.props;

    if (this.state.empty) { this.setState({ empty: false }); }

    let postData = data;
    if (!data) {
      postData = {
        entity,
        entity_id: this.props.entityId,
        complaint: this.textItemId,
        user_desc: this.textareaRef.value,
        url: this.props.url
      };
    }

    this.api.post(`form/domik/${entity}-complaint/data`, {
      postData: { captcha: this.state.captcha, ...postData, project: __PROJECT__ }
    })
      .then(() => {
        this.props.closeModal(true);
        emit(updateEvent);
        return Notification.success(this.i18n('complaintMassage'), null);
      })
      .catch(error => reportError(error));
  }

  complainHandleClick(item) {
    const { entityId, userComplaintHandle, changeStep, currentStep } = this.props;

    if (isEmpty(item.children)) {
      if (!item.user_desc_needed) {
        const data = {
          entity_id: entityId,
          complaint: item.id,
          url: this.props.url
        };
        return this.sendComplaint(data);
      }

      userComplaintHandle();
      return this.textItemId = item.id;
    }

    if (!isEmpty(item.children)) {
      if (this.stepItem.length < currentStep) {
        this.stepItem.push(item);
      } else if (
        this.stepItem.length === currentStep &&
        !isEqual(this.stepItem[currentStep - 1], item)
      ) {
        this.stepItem = this.stepItem.slice(-1);
        this.stepItem.push(item);
      }
    }

    changeStep(item.title);
    return userComplaintHandle(true);
  }

  renderComplaints(children) {
    const { userComplaint } = this.props;

    return (
      map(children, (item, index) => (
        <Button
          key={index}
          {...bemClasses('btn', userComplaint && item.id === this.textItemId ? 'hovered' : '')}
          onClick={() => this.complainHandleClick(item)}
          inListDD
          customRenderer
        >
          <span {...bemClasses('btnContent')} data-test="btnContent">
            <span {...bemClasses('text')} children={item.title} />
            {!isEmpty(item.children) &&
              <Icon {...bemClasses('icon', 'right')} type={iconTypes.arrowSliderRight} />
            }
          </span>
        </Button>
      ))
    );
  }

  putStorageName =(val)=> {this.storageUserDataPut(val, `ask_question_name`)};

  putStoragePhone =(val)=> {this.storageUserDataPut(val, `ask_question_phone`)};

  putStorageEmail =(val)=> {this.storageUserDataPut(val, `ask_question_email`)};

  storageUserDataPut(value, entity) {localStorage.emit(entity, value);}

  storageUserDataGet(key) {return localStorage.get(key) || '';}

  render() {
    const { i18n } = this;
    const { data, userComplaint, currentStep, entityId, entity, url } = this.props;
    let children = data;

    if (currentStep !== 1) {
      children = this.stepItem[currentStep - 2].children;
    } else {
      this.stepItem = [];
    }

    const formData = { entity_id: entityId, entity, url, complaint: this.textItemId };

    if (get(this, 'props.auth.id')) {
      if (!this.storageUserDataGet('ask_question_name')){
        this.storageUserDataPut(this.props.auth.name, `ask_question_name`);
      }
      if (!this.storageUserDataGet('ask_question_phone')){
        this.storageUserDataPut(this.props.auth.phone, `ask_question_phone`);
      }
      if (!this.storageUserDataGet('ask_question_email')){
        this.storageUserDataPut(this.props.auth.email, `ask_question_email`);
      }
    }

    formData.name = this.storageUserDataGet('ask_question_name');
    formData.phone = this.storageUserDataGet('ask_question_phone');
    if (!formData.phone) delete formData.phone;
    formData.email = this.storageUserDataGet('ask_question_email');
    formData.project = __PROJECT__;

    return (
      <div {...bemClasses()}>
        {/* remove to activate Recaptcha
        {!auth.authenticated &&
          <RecaptchaButton onChange={captcha => this.setState({ captcha })} />
        } */}
        {this.renderComplaints(children)}
        {userComplaint &&
          <Form
            {...bemClasses('form')}
            controller="domik/user-complaint"
            showPopupValidationMessages
            resetAfterSubmit
            data={formData}
            defaultValues={formData}
            defaultSuccessHeader={i18n('complaintMassageDefault')}
            // onErrorSubmit={this.onErrorSubmit}
            onSubmit={this.onSubmit}
          >
            <Row {...bemClasses('row')} allColumn>
              <Col
                {...bemClasses('col', 'userForm')}
                allPr={0}
                children={userForm.call(this, bemClasses)}
              />
              <Col {...bemClasses('col', 'textarea')} allFlex allPr={0}>
                <div {...bemClasses('textareaContainer')}>
                  <Text
                    {...bemClasses('textarea')}
                    dataBind="user_desc"
                    hasLabel={false}
                  />
                </div>
              </Col>
            </Row>
            <div {...bemClassesModalFooter()}>
              <div {...bemClassesModalFooter('contentContainer')}>
                <div {...bemClassesModalFooter('content')}>
                  <Button
                    {...bemClassesModalFooter('btn', 'send')}
                    theme={btnThemes.olive}
                    type="submit"
                    label={i18n('complaintBtnSendText')}
                  />
                </div>
              </div>
            </div>
          </Form>
        }
      </div>
    );
  }
}

export default ComplaintContainer;
